import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';

import { useTranslation } from 'react-i18next';

// leaflet
import L from 'leaflet';
import {
  Map,
  Marker,
  Popup,
  Tooltip,
  LayerGroup,
  LayersControl,
  TileLayer,
} from 'react-leaflet';
import Control from 'react-leaflet-control';
import 'leaflet/dist/leaflet.css';
import FullscreenControl from 'react-leaflet-fullscreen';
import { GestureHandling } from 'leaflet-gesture-handling';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';
import { Hidden } from '@material-ui/core';
import LeafletFullScreenFix from '../../../utils/map/LeafletFullScreenFix';
// import withWidth from '@material-ui/core/withWidth';

// components
import mapConfig from '../../../components/map/Config';
import LayerRiver from '../../../components/map/River';
import WaterQualityStatusColor from './WaterQualityStatusColor';
import LayerProvince from '../../../components/map/Province';
import LayerBasin from '../../../components/map/Basin';
import WaterQualityChart from '../chart/WaterQualityChart';

// icon
// eslint-disable-next-line import/order
import MyLocationIcon from '@material-ui/icons/MyLocation';
import { FaSquare, FaChartLine } from '../../../assets/font/Fontawesome';

// style
import { styles } from './style';

const useStyles = makeStyles(styles);
const { Overlay, BaseLayer } = LayersControl;

export default function WaterQualityMap(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const refMap = useRef(null);
  const WaterqualityLayer = useRef(null);
  const [keyword, setKeyword] = useState('กรด-ด่าง');
  const [currentPosition, setCurrentPosition] = useState();
  // const [valueType] = useState('salinity');
  const {
    markers,
    datas,
    handleSetMap,
    handleModalOpen,
    currentMode,
    currentArea,
    handleChangeLegend,
  } = props;

  const handleChart = (data) => (e) => {
    e.preventDefault();
    const params = {
      open: true,
      header: t('เปรียบเทียบสถานีคุณภาพน้ำ'),
      subheader: null,
      content: <WaterQualityChart
        id={data.waterquality_station.id}
        provinceId={data.waterquality_station.province_code}
      />,
    };
    handleModalOpen(params);
  };

  const bindMarker = (id) => (ref) => {
    if (ref) {
      markers[id] = ref.leafletElement;
      if (refMap.current.leafletElement) {
        const map = refMap.current.leafletElement;
        markers[id].addEventListener('click', (e) => {
          const { lat } = e.target.getLatLng();
          const { lng } = e.target.getLatLng();
          map.panTo([lat, lng]);
        });
      }
    }
  };

  function setIcon(val, types) {
    const status = WaterQualityStatusColor(val, types);
    return status.icon;
  }

  // function conditionColor(code) {
  //   if (code === '#66C803' || code === '#FFD966') {
  //     return '#000000';
  //   }
  //   return '#FFFFFF';
  // }

  function waterQualityStatusBadge(data, value, key) {
    const status = WaterQualityStatusColor(data, key);
    const statusText = `
      <div
        style=background:${status.color.statusColor};text-align:center;width:60px;color:${status.color.color};
      >
      ${Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </div>`;
    return typeof value === 'undefined' || value == null ? '-' : statusText;
  }

  function renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i) {
    return (
      <Marker
        id={data.id}
        key={i}
        position={position}
        icon={icon}
        ref={bindMarker(data.id)}
        classes={classes}
      >
        <Popup autoPan={false}>
          <TableContainer style={{ height: 250 }}>
            <Table size="small">
              <TableHead />
              <TableBody>
                <TableRow>
                  <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                    <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                      {
                        (data.waterquality_station.waterquality_station_name.th).includes('สถานี') ? data.waterquality_station.waterquality_station_name.th : `สถานี${data.waterquality_station.waterquality_station_name.th}`
                      }
                    </Box>
                    <Box fontFamily="Kanit" fontSize="12px">
                      {data.waterquality_station.tumbon_name.th !== '' ? `ต. ${data.waterquality_station.tumbon_name.th} ` : null}
                      {`อ. ${data.waterquality_station.amphoe_name.th} `}
                      {`จ. ${data.waterquality_station.province_name.th}`}
                    </Box>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell padding="none" align="center" colSpan={3} style={{ paddingTop: 15 }} />
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine} style={{ paddingTop: 6 }}>
                    <Box fontWeight={600} fontSize={12}>
                      {t('กรด-ด่าง')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center">
                    <Box
                      className={`${classes.status}`}
                      style={{ whiteSpace: 'nowrap' }}
                      dangerouslySetInnerHTML={{ __html: WqPh }}
                    />
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center" />
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine}>
                    <Box fontWeight={600} fontSize={12}>
                      {t('ความเค็ม')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center">
                    <Box
                      className={`${classes.status}`}
                      dangerouslySetInnerHTML={{ __html: WqSalinity }}
                    />
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="left">(g/L)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine}>
                    <Box fontWeight={600} fontSize={12}>
                      {t('ความขุ่น')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center">
                    <Box
                      className={`${classes.status}`}
                      dangerouslySetInnerHTML={{ __html: WqTurbid }}
                    />
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="left">(ntu)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine}>
                    <Box fontWeight={600} fontSize={12}>
                      {t('สารละลาย')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center">
                    <Box
                      className={`${classes.status}`}
                      dangerouslySetInnerHTML={{ __html: WqTds }}
                    />
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="left">(mg/L)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.hiddenLine}>
                    <Box fontWeight={600} fontSize={12}>
                      {t('ออกซิเจน')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="center">
                    <Box
                      className={`${classes.status}`}
                      dangerouslySetInnerHTML={{ __html: WqDo }}
                    />
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="left">(mg/L)</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell padding="none" align="center" colSpan={3} style={{ paddingTop: 10 }} />
                </TableRow>
                <TableRow>
                  <TableCell
                    className={classes.hiddenLine}
                    style={{ paddingTop: 10 }}
                    colSpan={2}
                  >
                    <Box color="text.disabled" fontSize="8px">{`${t('ข้อมูล')}: ${data.waterquality_station.agency_name.th}`}</Box>
                    <Box color="text.disabled" fontSize="8px">
                      {t('ล่าสุด')}
                      {' : '}
                      {data.waterquality_datetime}
                      {' '}
                      {t('น')}
                    </Box>
                  </TableCell>
                  <TableCell className={classes.hiddenLine} align="right">
                    <Button
                      id="icon_chart"
                      title={t('แสดงกราฟ')}
                      style={{ padding: 0, minWidth: 18 }}
                      onClick={handleChart(data)}
                    >
                      <FaChartLine className={classes.rightIcon} />
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Popup>
        <Hidden smDown>
          <Tooltip>
            <span>
              <strong>
                {data.waterquality_station.waterquality_station_name.th}
              </strong>
              <br />
              {`${t('ต.')} ${data.waterquality_station.tumbon_name.th}`}
              <br />
              {`${t('อ.')} ${data.waterquality_station.amphoe_name.th}`}
              <br />
              {`${t('จ.')} ${data.waterquality_station.province_name.th}`}
            </span>
          </Tooltip>
        </Hidden>
      </Marker>
    );
  }

  const eachData = (data, i) => {
    if (
      data.waterquality_station.waterquality_station_lat
      && data.waterquality_station.waterquality_station_long
    ) {
      const position = [
        parseFloat(data.waterquality_station.waterquality_station_lat),
        parseFloat(data.waterquality_station.waterquality_station_long),
      ];
      const WqSalinity = waterQualityStatusBadge(
        data.waterquality_salinity,
        data.waterquality_salinity,
        'salinity',
      );
      const WqPh = waterQualityStatusBadge(
        data.waterquality_ph,
        data.waterquality_ph,
        'ph',
      );
      const WqDo = waterQualityStatusBadge(
        data.waterquality_do,
        data.waterquality_do,
        'do',
      );
      const WqTurbid = waterQualityStatusBadge(
        data.waterquality_turbid,
        data.waterquality_turbid,
        'turbid',
      );
      const WqTds = waterQualityStatusBadge(
        data.waterquality_tds,
        data.waterquality_tds,
        'tds',
      );
      if (keyword === 'กรด-ด่าง') {
        const icon = setIcon(
          parseFloat(data.waterquality_ph),
          'ph',
        );
        return renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i);
      }

      if (keyword === 'ความเค็ม') {
        const icon = setIcon(
          parseFloat(data.waterquality_salinity),
          'salinity',
        );
        return renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i);
      }

      if (keyword === 'ความขุ่น') {
        const icon = setIcon(
          parseFloat(data.waterquality_turbid),
          'turbid',
        );
        return renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i);
      }

      if (keyword === 'สารละลาย') {
        const icon = setIcon(
          parseFloat(data.waterquality_tds),
          'tds',
        );
        return renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i);
      }

      if (keyword === 'ออกซิเจน') {
        const icon = setIcon(
          parseFloat(data.waterquality_do),
          'do',
        );
        return renderMarker(data, position, icon, WqSalinity, WqPh, WqDo, WqTurbid, WqTds, i);
      }
    }
    return false;
  };

  const baseLayerChange = (event) => {
    handleChangeLegend(event.name);
    setKeyword(event.name);
  };

  const handleLayerControlsChange = (event) => {
    const { target } = event;
    target.on('baselayerchange', baseLayerChange);
  };

  const goToCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setCurrentPosition([latitude, longitude]);
      refMap.current.leafletElement.setView([latitude, longitude], 16, {
        animate: true,
      });
    },
    () => false,
    { enableHighAccuracy: true });
  };

  const handleScroll = () => window.scrollTo(0, 0);

  useEffect(() => {
    handleSetMap(refMap.current.leafletElement);
    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    window.scrollTo(0, 0);
  }, [handleSetMap, currentMode, currentArea]);

  return (
    <div className={classes.root}>
      <Map
        id="map"
        center={currentArea.location ? currentArea.location : mapConfig.center}
        zoomSnap={0}
        zoomDelta={0.5}
        ref={refMap}
        style={{ height: 770, zIndex: 0 }}
        bounds={L.latLngBounds(currentArea.top_left, currentArea.bottom_right)}
        boundsOptions={{ padding: [50, 50] }}
        gestureHandling
        whenReady={handleLayerControlsChange}
        onZoomEnd={handleScroll}
      >
        <Control position="bottomleft">
          <div className="info">
            <Typography variant="body1">
              <FaSquare style={{ color: '#808080' }} />
              {t('ไม่มีข้อมูล')}
            </Typography>
          </div>
        </Control>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          id="OpenStreetMap"
          attribution='&copy; <a href="http://osm.org/copyright">ESRI World Street Map</a> contributors'
        />
        {currentMode === 'province' && (
          <LayerProvince areaType={0} areaId={currentArea.code} />
        )}
        {currentMode === 'basin' && (
          <LayerBasin areaType={1} areaId={currentArea.code} />
        )}
        <LayersControl position="topright">
          <Overlay name={t('เส้นแม่น้ำ')} checked>
            <LayerRiver />
          </Overlay>
          <BaseLayer name={t('กรด-ด่าง')} checked>
            <LayerGroup ref={WaterqualityLayer}>
              {orderBy(datas, ['waterquality_ph', ['desc']]).map(eachData)}
            </LayerGroup>
          </BaseLayer>
          <BaseLayer name={t('ความเค็ม')}>
            <LayerGroup ref={WaterqualityLayer}>
              {orderBy(datas, ['waterquality_salinity', ['desc']]).map(
                eachData,
              )}
            </LayerGroup>
          </BaseLayer>
          <BaseLayer name={t('ความขุ่น')}>
            <LayerGroup ref={WaterqualityLayer}>
              {orderBy(datas, ['turbid', ['desc']]).map(eachData)}
            </LayerGroup>
          </BaseLayer>
          <BaseLayer name={t('สารละลาย')}>
            <LayerGroup ref={WaterqualityLayer}>
              {orderBy(datas, ['waterquality_tds', ['desc']]).map(eachData)}
            </LayerGroup>
          </BaseLayer>
          <BaseLayer name={t('ออกซิเจน')}>
            <LayerGroup ref={WaterqualityLayer}>
              {orderBy(datas, ['waterquality_do', ['desc']]).map(eachData)}
            </LayerGroup>
          </BaseLayer>
        </LayersControl>
        <FullscreenControl
          position="topleft"
          forcePseudoFullscreen
          content={LeafletFullScreenFix()}
        />
        <Control position="topleft">
          <div className="info">
            <Button
              onClick={goToCurrentPosition}
              style={{
                width: 20,
                minWidth: 20,
                height: 20,
                minHeight: 20,
              }}
            >
              <MyLocationIcon />
            </Button>
          </div>
        </Control>
        {currentPosition && (
          <Marker position={currentPosition} icon={L.icon({ iconUrl: 'marker-icon.png', popupAnchor: [12.5, 0] })}>
            <Popup>
              <div>
                <p>{t('ตำแหน่งปัจจุบัน')}</p>
              </div>
            </Popup>
          </Marker>
        )}
        {datas.map(eachData)}
      </Map>
    </div>
  );
}

WaterQualityMap.propTypes = {
  markers: PropTypes.instanceOf(Array).isRequired,
  datas: PropTypes.instanceOf(Array).isRequired,
  handleSetMap: PropTypes.func.isRequired,
  handleModalOpen: PropTypes.func.isRequired,
  handleChangeLegend: PropTypes.func.isRequired,
  currentMode: PropTypes.string.isRequired,
  currentArea: PropTypes.instanceOf(Object).isRequired,
};
